import $ from "jquery";

export default  class PostcoderAddress {
    constructor(config) {
        this.config = config;
        this.init();
    }

    init = () => {
        this.endpoint =
            "https://ws.postcoder.com/pcw/" + this.config.apikey + "/address/";
        this.addresses = {};

        this.searchbutton = document.querySelector(this.config.searchbutton);
        this.searchterminput = document.querySelector(this.config.searchterm);

        // Hide the no result message
        this.noresultmessage = document.querySelector(
            this.config.noresultmessage
        );
        this.noresultmessage.style.display = "none";

        // Create an empty select and place it hidden in the page
        this.select = document.createElement("select");
        this.select.style.display = "none";
        document
            .querySelector(this.config.addressselectioncontainer)
            .appendChild(this.select);

        // Create and append the top 'select an address' option.
        let option = document.createElement("option");
        option.text = "Select an address";
        this.select.appendChild(option);

        // Add select change event listener to the dropdown
        this.select.addEventListener("change", this.handleSelectChange);

        // Add click event listener to the search button, to call the search function
        this.searchbutton.addEventListener("click", this.search);

        // Add 'enter' event listener to the search input, to call the search function
        this.searchterminput.addEventListener("keyup", event => {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.search();
            }
        });

        // Determine the number of addresslines required
        this.addresslines = 0;
        for (let i = 1; i <= 4; i++) {
            if (this.config["addressline" + i] !== "") {
                this.addresslines++;
            }
        }
    };

    handleSelectChange = event => {
        // Check to see if this selection was to load the next page of results
        if (this.select.value.charAt(0) === "p") {
            // Search the next page of results
            let page = this.select.value.substring(1);
            this.search(event, page);
        } else {
            this.selectAddress(this.select.value);
        }
    };

    search = (event, page = 0) => {
        let searchterm = encodeURIComponent(this.searchterminput.value);
        const addtags = "&addtags=udprn"

        // Hide the no result message
        this.noresultmessage.style.display = "none";

        // Hide the select
        this.select.style.display = "none";

        // Determine the country; either defined in config
        // or from the dropdown.
        const country =
            typeof this.config.countrycode !== "undefined" &&
            this.config.countrycode !== ""
                ? this.config.countrycode
                : document.querySelector(this.config.country).value;

        // If page 0, remove any previous options
        if (page === 0) {
            while (this.select.options.length > 1) {
                this.select.remove(1);
            }
        } else {
            // Remove the bottom 'next page' option
            this.select.remove(this.select.options.length - 1);
        }

        // Fetch the json formatted result from Postcoder and pass it to processResult
        fetch(
            this.endpoint +
            country +
            "/" +
            searchterm +
            "?lines=" +
            this.addresslines +
            "&exclude=organisation,country&page=" +
            page +
            addtags
        )
            .then(response => {
                if (!response.ok) {
                    throw response;
                }
                return response.json();
            })
            .then(json => {
                this.processResult(json);
            })
            .catch(err => {
                if (typeof err.text === "function") {
                    err.text().then(errorMessage => {
                        console.log(
                            "Postcoder request error " +
                            err.status +
                            " : " +
                            errorMessage
                        );
                    });
                } else {
                    console.log(err);
                }
                this.showFallback();
            });
    };

    showFallback = () => {
        // Show the no result message
        this.noresultmessage.style.display = "block";

        // Hide selected address if present
        const selectedAddress = document.getElementById('selectedAddress');
        if(selectedAddress) {
            selectedAddress.style.display = "none";
        }
    }

    processResult = addresses => {
        this.addresses = addresses;


        // If zero results, ask for manual address entry
        if (addresses.length === 0) {
            this.showFallback();

        }
        // If one result, populate the form
        else if (addresses.length === 1) {
            this.selectAddress(0);
        }
        // Multiple addresses, show drop down to select from
        else {
            // Create and append the address options, using the summaryline of the returned addresses
            for (let i = 0; i < addresses.length; i++) {
                let option = document.createElement("option");
                option.value = i;
                option.text = addresses[i].summaryline;
                this.select.appendChild(option);
            }

            // If there are morevalues, add paging
            if (
                this.addresses[this.addresses.length - 1]["morevalues"] ===
                "true"
            ) {
                // Add a 'load next page' option
                let option = document.createElement("option");
                option.value =
                    "p" + this.addresses[this.addresses.length - 1]["nextpage"];

                // Last address contains total number of results, show the user how many are remaining
                let remainingresults =
                    this.addresses[this.addresses.length - 1]["totalresults"] -
                    this.select.options.length +
                    1;

                option.text =
                    "Load more results, " +
                    remainingresults +
                    " of " +
                    this.addresses[this.addresses.length - 1]["totalresults"] +
                    " remaining";
                this.select.appendChild(option);
            }

            // Ensure the select is visible
            this.select.style.display = "block";
        }
    };

    selectAddress = i => {
        // Get the selected address
        let address = this.addresses[i];

        //console.log(address)

        const stepAddressLookupButton = document.getElementById('stepAddressLookupButton');
        stepAddressLookupButton.classList.remove('btn-hide');

        let fields = [
            "organisation",
            "addressline1",
            "addressline2",
            "addressline3",
            "addressline4",
            "posttown",
            "county",
            "number",
            "premise",
            "postcode",
            "uniquedeliverypointreferencenumber",
        ];

        // Populate the address form
        for (let i = 0; i < fields.length; i++) {
            let field_selector = this.config[fields[i]];
            if (
                typeof field_selector !== "undefined" &&
                field_selector !== ""
            ) {
                document.querySelector(field_selector).value =
                    typeof address[fields[i]] !== "undefined"
                        ? address[fields[i]]
                        : "";
            }
        }



        // Populate selected address txt
        const selectedAddress = document.getElementById('selectedAddress');
        if(selectedAddress) {

            selectedAddress.style.display = "block";

            for (let i = 0; i < fields.length; i++) {
                let field_selector = this.config[fields[i]] + "_text";
                if (
                    typeof field_selector !== "undefined" && field_selector
                ) {
                    const target_text = document.querySelector(field_selector);
                    if(target_text) {
                        target_text.innerHTML = address[fields[i]]
                    }
                }
            }
        }

    };
}
